import { Theme } from './theme.model';

export const dark: Theme = {
  title: 'dark',

  colors: {
    background: '#222222',

    primary: '#006699',
    secondary: '#93abba',

    notSelected: '#555555',
    selected: '#006699',

    divider: '#555555',

    h1: '#ffffff',
    p: '#bbbcbe',

    formH1: '#fff',
    formP: '#aaa',
    formBorder: '#444',
    formBackground: '#333',
    formLabel: '#aaa',

    formInputBackground: '#444',
    formInputBorder: '#555',
    formInputBorderHover: '#777',
    formInputBorderFocus: '#ccc',
    formInputColor: '#fff',

    formButtonBackground: '#444',
    formButtonBackgroundHover: '#555',
    formButtonBorder: '#555',
    formButtonColor: '#fff',

    loading: '255, 255, 255',

    buttonRemove: '#C0003C',
    buttonAdd: '#008D73',

    progressIcon: '#fff',
  },
};
